export default "__VITE_ASSET__5EvpDP$J__"